export default __webpack_public_path__ + "static/media/Animation.f567bcf8.mp4";